<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <div class="row form-group">

        <div class="col">
          <AppAddButton v-bind:permission="permission">
          <button @click.prevent="onAddButtonClick" class="btn btn-rounded btn-block-xs-only" style="background: rgb(38, 198, 218); color: #fff;">
            Add Car Park Zone
          </button>
          </AppAddButton>
        </div>

        <AppSearch 
          ref="pageSearch"
          class="col-md-4"
          v-on:search-data-change="onSearchChange" />
        
      </div>

      <AppFilter 
        ref="pageFilter" 
        filterKey="carparkID"
        v-on:filter-data-change="onFilterDataChange" />
      
      <AppTable 
        ref="pageTable" 
        v-bind:tableParameter="PARAM" 
        v-bind:permission="permission"
        v-on:table-data-click="onTableDataClick" 
        v-on:table-page-change="onTablePageChange" />
      
      <AppTable 
        ref="pageBay" 
        v-bind:tableParameter="BAY_PARAM" 
        v-bind:permission="permission" />

      <TemplateFeedback ref="pageFeedback" />
      
      <AppModalForm 
        ref="pageModal" 
        v-bind:formParameter="PARAM" 
        v-bind:permission="permission"
        v-on:modal-data-add="onModalAddDataClick"
        v-on:modal-data-edit="onModalEditDataClick"
        v-on:modal-data-delete="onModalDeleteDataClick" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');

const BAY_PARAM = [
  {
    key: 'type',
    text: 'Bay Type',
  },
  {
    key: 'allocation',
    text: 'Allocation (A)',
  },
  {
    key: 'oversell',
    text: 'Oversell (B)',
  },
  {
    key: 'used',
    text: 'Used (C)',
  },
  {
    key: 'entitlement',
    text: 'Entitlement (D)',
  },
  {
    key: 'entitlementUsed',
    text: 'Entitlement Used (E)',
  },
  {
    key: 'remain',
    text: '(A+B-C-D) Remain',
  },
];

const PARAM = [
  {
    key: '_index',
    index: true,
  },
  {
    key: 'carparkID',
    text: 'Car Park',
    table_hide: true,
    form_select: [],
    form_chosen: true,
    form_edit_input_attr: {
      disabled: true,
    }
  },
  {
    key: 'name',
    text: 'Zone Name',
    table_popup: true, 
  },
  {
    key: 'ReservedCount',
    table_head: 'Reserved',
    text: 'Reserved Bay Count',
    form_default: 0,
    form_input_attr: {
      'type': 'Number',
    },
  },
  {
    key: 'TandemCount',
    table_head: 'Tandem-Reserved',
    text: 'Tandem-Reserved Bay Count',
    form_default: 0,
    form_input_attr: {
      'type': 'Number',
    },
  },
  {
    key: 'NonReservedCount',
    table_head: 'Non-Reserved',
    text: 'Non-Reserved Bay Count',
    form_default: 0,
    form_input_attr: {
      'type': 'Number',
    },
  },
  {
    key: 'MotorcycleCount',
    table_head: 'Motorcycle',
    text: 'Motorcycle Bay Count',
    form_default: 0,
    form_input_attr: {
      'type': 'Number',
    },
  },
  {
    key: 'VisitorCount',
    table_head: 'Visitor',
    text: 'Visitor Bay Count',
    form_default: 0,
    form_input_attr: {
      'type': 'Number',
    },
  },
  {
    key: '_total',
    text: 'Total',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return dataItem.ReservedCount + dataItem.TandemCount + dataItem.NonReservedCount + dataItem.MotorcycleCount + dataItem.VisitorCount;
    },
    form_hide: true,
    form_input_validation: [],
  },
  {
    key: 'OversellCount',
    table_head: 'Oversell (NR)',
    text: 'Non-Reserved Allowable Oversell',
    form_default: 0,
    form_input_attr: {
      'type': 'Number"',
    },
    form_input_validation: [],
  },
  {
    key: '_oversellTotal',
    text: 'Total + Oversell (NR)',
    form_hide: true,
    form_input_validation: [],
  },
];

const PARAM_MAP = helper.transformParamToMap(PARAM);

export default {
  name: "PageZone",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppFilter,
    AppTable,
    AppAddButton,
    AppModalForm,
    TemplateFeedback,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Car Park', url: '/carpark' },
        { name: 'Zone' },
      ],

      PARAM,
      PARAM_MAP,
      BAY_PARAM,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.$refs['pageFilter'].formatFilterOptionText = (dataItem) => dataItem.carparkCode ? `${dataItem.carparkCode} - ${dataItem.name}` : dataItem.name;
    this.loadCarpark();
  },
  methods: {
    loadCarpark() {
      this.$refs['pageFilter'].setFilterLoading('Loading car park data...');

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.carparkID);
          // this.$refs['pageFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All Car Parks'}, response.data), this.$route.query.carparkID);
          helper.inputSelectSetOption(this.PARAM_MAP['carparkID'], response.data);
          this.loadData();
        })
        .catch(error => {
          this.$refs['pageFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', 'car park data'));
        });
    },
    loadData() {
      let feedbackItem = 'zone data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$refs['pageTable'].setTableData();
      this.$refs['pageBay'].setTableData();

      let url = this.getUrl(this.$refs['pageFilter'].filterValue);
      url = helper.appendSearchQuery(url, this.$refs['pageSearch'].searchValue);
      url = helper.appendPagingQuery(url, this.$refs['pageTable'].getCurrentPage());
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response, true);
          this.pageZone = response.data;
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.loadBay();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadBay() {
      let feedbackItem = 'bay data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$refs['pageTable'].setTableData();
      this.$refs['pageBay'].setTableData();

      let url = helper.SERVER_URL + '/api2';
      url += '/bay/?1=1';
      let carparkFilter = this.$refs['pageFilter'].filterValue;
      if(carparkFilter) {
        url += '&carparkID=' + carparkFilter;
      }
      // url += '&page=1';
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response, false);
          let tempBay = {};
          response.data.forEach(k => {
            if(k.bayType === 'NA') {
              return;
            }

            let temp = tempBay[k.bayType] = tempBay[k.bayType] || {
              'type': k.bayType,
              'allocation': 0,
              'oversell': 0,
              'used': 0,
              'entitlement': 0,
              'entitlementUsed': 0,
              'remain': 0
            };

            if(k.seasonID) {
              temp['allocation']++;
            }
            if(k.customerID) {
              temp['entitlement']++;
            }
            if(k.leaseID) {
              if(k.customerID) {
                temp['entitlementUsed']++;
              } else {
                temp['used']++;
              }
            }
            temp['remain'] = temp['allocation'] + temp['oversell'] - temp['used'] - temp['entitlement'];
          });
          let finalBay = Object.values(tempBay);
          this.$refs['pageFeedback'].setFeedbackMessage();
          // this.$refs['pageBay'].setTableData(finalBay);
          this.$refs['pageTable'].setTableData(this.pageZone, this.$refs['pageTable'].getCurrentPage());
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },

    getUrl(carparkID) {
      let url = helper.SERVER_URL + '/api2';
      if(carparkID) {
        url += '/carpark/' + carparkID;
      }
      url += '/zone/';

      return url;
    },

    onTablePageChange() {
      this.loadData();
    },
    onSearchChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.loadData();
    },
    onFilterDataChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.loadData();
    },

    onAddButtonClick() {
      this.$refs['pageFeedback'].setFeedbackMessage();
      
      let defaultData = this.$refs['pageModal'].$refs['modalForm'].getFormDefaultData();
      defaultData['carparkID'] = this.$refs['pageFilter'].filterValue;

      this.$refs['pageModal'].setModalOpen(true, 'Add New Car Park Zone', defaultData);
    },
    onTableDataClick(tableData, tableDataIndex) {
      this.$refs['pageFeedback'].setFeedbackMessage();
      this.$refs['pageModal'].setModalOpen(false, 'Edit ' + tableData[tableDataIndex]['name'], tableData[tableDataIndex]);
    },

    onModalAddDataClick(selectedData) {
      this.$refs['pageModal'].setModalLoading('Adding ' + selectedData.name);
      
      this.$http
        .post(
          this.getUrl(selectedData.carparkID),
          querystring.stringify(selectedData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFilter'].setFilterValue(selectedData.carparkID);
          this.upsertDataComplete('Successfully added ' + selectedData.name);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'adding', 'data'));
        })
    },
    onModalEditDataClick(selectedData) {
      this.$refs['pageModal'].setModalLoading('Updating ' + selectedData.name);

      this.$http
        .put(
          this.getUrl(selectedData.carparkID) + selectedData.id,
          querystring.stringify(selectedData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully update ' + selectedData.name);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'updating', 'data'));
        })
    },
    onModalDeleteDataClick(selectedData) {
      this.$refs['pageModal'].setModalLoading('Deleting ' + selectedData.name);

      this.$http
        .delete(
          this.getUrl(selectedData.carparkID) + selectedData.id,
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully delete ' + selectedData.name);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'deleting', 'data'));
        })
    },
    upsertDataComplete(message) {
      this.$refs['pageModal'].setModalClose();
      this.$refs['pageFeedback'].setFeedbackMessage(message);
      this.loadData();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/CarPark/PageZone.vue